import { GetRefrigerationUnitModelsQuery } from '@/graphql/GetRefrigerationUnitModels.generated';

import { store } from './store';

export type RefrigerationUnitModelsFilter =
  GetRefrigerationUnitModelsQuery['container_insights_refrigeration_unit_models'][0] & {
    selected: boolean;
  };

// init store
const setRefrigerationUnitModels = (
  models: GetRefrigerationUnitModelsQuery['container_insights_refrigeration_unit_models'],
) => {
  store.refrigerationUnitModels = models.map((model) => ({
    ...model,
    selected: false,
  }));
};

const getRefrigerationUnitModel = (
  id: string,
): RefrigerationUnitModelsFilter | null => {
  const model = store.refrigerationUnitModels.find((model) => model.id === id);
  return model || null;
};

const setSelectedRefrigerationUnitModels = (ids: string[]) => {
  store.refrigerationUnitModels.forEach((model) => {
    model.selected = ids.includes(model.id);
  });
};

const unselectAllRefrigerationUnitModels = () => {
  store.refrigerationUnitModels.forEach((model) => {
    model.selected = false;
  });
};

const selectRefrigerationUnitModel = (id: string) => {
  const model = getRefrigerationUnitModel(id);
  if (model) {
    model.selected = true;
  }
};

const unselectRefrigerationUnitModel = (id: string) => {
  const model = getRefrigerationUnitModel(id);
  if (model) {
    model.selected = false;
  }
};

const selectRefrigerationUnitModels = (ids: string[]) => {
  ids.map(getRefrigerationUnitModel).forEach((model) => {
    if (model) {
      model.selected = true;
    }
  });
};

const unselectRefrigerationUnitModels = (ids: string[]) => {
  ids.map(getRefrigerationUnitModel).forEach((model) => {
    if (model) {
      model.selected = false;
    }
  });
};

const toggleRefrigerationUnitModel = (id: string) => {
  const model = getRefrigerationUnitModel(id);
  if (model) {
    model.selected = !model.selected;
  }
};

const toggleManufacturer = (name: string) => {
  const models = store.refrigerationUnitModels.filter(
    (model) => model.manufacturer.name === name,
  );
  const someSelected = models.some((model) => model.selected);
  models.forEach((model) => (model.selected = !someSelected));
};

export {
  setRefrigerationUnitModels,
  setSelectedRefrigerationUnitModels,
  getRefrigerationUnitModel,
  toggleManufacturer,
  unselectAllRefrigerationUnitModels,
  selectRefrigerationUnitModel,
  unselectRefrigerationUnitModel,
  toggleRefrigerationUnitModel,
  selectRefrigerationUnitModels,
  unselectRefrigerationUnitModels,
};
